module.exports = __webpack_public_path__ + "img/1_AR-mb.ed27da0a.png";